import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ControlContainer, FormGroup } from '@angular/forms';
import { PessoaJuridicaDTO } from 'app/model/dtos/grl/pessoa-juridica.dto';
import { PessoaJuridicaService } from 'app/services/grl/pessoa-juridica.service';
import { ParentFormGroup } from 'app/tools/parent-formgroup';
import { DialogFactory } from 'sol-tools-ts/dist';

@Component({
  selector: 'text-cnpj',
  templateUrl: './text-cnpj.component.html',
  styleUrls: ['./text-cnpj.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class TextCnpjComponent implements OnInit {

  formGroup: FormGroup;
  @Output() resultPessoaJuridica: EventEmitter<PessoaJuridicaDTO> = new EventEmitter<PessoaJuridicaDTO>();

  constructor(
    private _controlContainer: ControlContainer,
    private _pessoaJuridicaService: PessoaJuridicaService,
    private _dialogFactory: DialogFactory
  ) { }

  ngOnInit() {
    this.formGroup = this._controlContainer.control as FormGroup;
  }

 async onChangeNrCNPJ($event) {
   let nrCnpj = $event.currentTarget.value.replace(/[^\d]+/gm,'');
   if (!nrCnpj) return;

   try{
     let pessoaJuridicaDTO: PessoaJuridicaDTO = await this._pessoaJuridicaService.getPessoaByCNPJ(nrCnpj);
     if (!pessoaJuridicaDTO || pessoaJuridicaDTO.cdPessoa == undefined) {
       this.formGroup.reset();
       this.formGroup.get("nrCnpj").setValue(nrCnpj);
       this.resultPessoaJuridica.emit(pessoaJuridicaDTO);
       return;
     }
  this.resultPessoaJuridica.emit(pessoaJuridicaDTO);
   } catch(error){
    this._dialogFactory.snack(error.message, "OK", DialogFactory.SNACK_WARNING, { duration: 10000 });
    this.formGroup.get('pessoa').reset();
    this.formGroup.get('pessoa').get('pessoaEndereco').reset();
   }
  }
}
